import { ADMIN_URL } from "../Constants/Config";
import axios from "axios";
export async function GetCurrencycodesAPI(type) {
  let dataDictionary = await axios.post(ADMIN_URL + "/common/GetCurrencycodes", {
    LookupTable: type,

  });
  return dataDictionary.data;
}